"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SearchResultsList = _interopRequireDefault(require("./SearchResultsList"));
var _SearchFilters = _interopRequireDefault(require("./SearchFilters"));
var _SearchBar = _interopRequireDefault(require("./SearchBar"));
var _lodash = require("lodash");
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchResults = props => {
  var [searchParams, setSearchParams] = (0, _react.useState)(new URLSearchParams(props.headTagsProps.pageQuery));
  var [error, setError] = (0, _react.useState)(null);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var [items, setItems] = (0, _react.useState)({
    src: [],
    frc: []
  });
  var [paramData, setParamData] = (0, _react.useState)(Object.fromEntries([...searchParams]));
  var showResults = searchMe => {
    setParamData({
      query: searchMe,
      type: '',
      page: 1
    });
  };
  (0, _react.useEffect)(() => {
    if (!(0, _lodash.isEmpty)(paramData.query) && !(0, _lodash.isNil)(paramData.query) && paramData.query !== 'undefined') {
      Promise.all([fetch("/apicalls/searchresults?searchterm=".concat(paramData.query, "&currentpage=").concat(paramData.page, "&filters=").concat(paramData.type)), fetch("/apicalls/searchresults?searchterm=".concat(paramData.query, "&currentpage=0"))]).then(_ref => {
        var [res, filteres] = _ref;
        return Promise.all([res.json(), filteres.json()]);
      }).then(_ref2 => {
        var [result, filteresult] = _ref2;
        setIsLoaded(true);
        setItems({
          src: result,
          frc: filteresult
        });
      }, error => {
        setIsLoaded(false);
        setError(error);
      });
    }
  }, [paramData]);
  var showAllResults = (allkey, isChecked) => {
    var pData = _objectSpread({}, paramData);
    setParamData({
      query: pData.query,
      type: '',
      page: 1
    });
  };
  var onCheckboxSel = (filterkey, isChecked) => {
    var pData = _objectSpread({}, paramData);
    var filter = pData.type === undefined ? '' : pData.type;
    if (isChecked) {
      filter = filter.trim().length === 0 ? filterkey : filter.concat("|".concat(filterkey));
    } else {
      var arr = !filter || filter.length === 0 ? [] : filter.split('|');
      var filterArray = arr.filter(item => item.toLowerCase() !== filterkey.toLowerCase());
      filter = filterArray.length === 1 ? filterArray.toString() : filterArray.join('|');
      filter = filter[0] === '|' ? filter.slice(1) : filter;
    }
    setParamData({
      query: pData.query,
      type: filter,
      page: 0
    });
  };
  var onPagingClick = listpage => {
    var prevPage = parseInt(listpage);
    var pData = _objectSpread({}, paramData);
    pData.page = prevPage;
    setParamData({
      query: pData.query,
      type: pData.type,
      page: pData.page
    });
  };
  var conditionalResults = noQuery => {
    var _items$src$showresult;
    if (error !== null || (0, _lodash.isNil)(noQuery) || ((_items$src$showresult = items.src.showresults) === null || _items$src$showresult === void 0 ? void 0 : _items$src$showresult.totalitems) === 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-5 aside-search"
      }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
        name: "left-rail",
        rendering: props.route,
        params: props.params
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-7 col-md-push-3 col-sm-push-0 search-results"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Found 0 items")), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
        className: "sm-head space-above-md space-below-lg"
      }, props.fields.noresultsMessage.value), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
        name: "main-content",
        rendering: props.route,
        params: props.params
      })))));
    } else {
      var _items$src$showresult2, _items$frc$showresult, _items$src$showresult3, _items$src$showresult4, _items$src$showresult5, _items$src$showresult6, _items$src$showresult7;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-4"
      }, ((_items$src$showresult2 = items.src.showresults) === null || _items$src$showresult2 === void 0 ? void 0 : _items$src$showresult2.totalitems) && /*#__PURE__*/_react.default.createElement(_SearchFilters.default, {
        scfields: props.fields,
        filteritms: (_items$frc$showresult = items.frc.showresults) === null || _items$frc$showresult === void 0 ? void 0 : _items$frc$showresult.allfacets,
        curlist: paramData.type,
        searchterm: paramData.query,
        onAllSelect: showAllResults,
        onSelect: onCheckboxSel,
        totalItems: (_items$src$showresult3 = items.src.showresults) === null || _items$src$showresult3 === void 0 ? void 0 : _items$src$showresult3.totalitems
      }), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
        name: "left-rail",
        rendering: props.route,
        params: props.params
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-md-8 search-results"
      }, ((_items$src$showresult4 = items.src.showresults) === null || _items$src$showresult4 === void 0 ? void 0 : _items$src$showresult4.totalitems) && /*#__PURE__*/_react.default.createElement(_SearchResultsList.default, {
        key: "filterkey".concat((_items$src$showresult5 = items.src.showresults) === null || _items$src$showresult5 === void 0 ? void 0 : _items$src$showresult5.totalitems),
        onPagingClick: onPagingClick,
        resultitms: (_items$src$showresult6 = items.src.showresults) === null || _items$src$showresult6 === void 0 ? void 0 : _items$src$showresult6.searchresults,
        totalItems: (_items$src$showresult7 = items.src.showresults) === null || _items$src$showresult7 === void 0 ? void 0 : _items$src$showresult7.totalitems,
        filters: paramData.type === undefined ? '' : paramData.type,
        page: paramData.page === undefined ? 1 : parseInt(paramData.page),
        searchterm: paramData.query,
        fields: props.fields,
        route: props.route,
        params: props.params,
        headTagsProps: props.headTagsProps
      })))));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SearchBar.default, {
    scfields: props.fields,
    searchterm: paramData.query === undefined ? '' : paramData.query,
    showresults: showResults
  }), conditionalResults(paramData.query));
};
var _default = exports.default = SearchResults;